import { render, staticRenderFns } from "./IssueReport.vue?vue&type=template&id=3dd7d5f1&scoped=true"
import script from "./IssueReport.vue?vue&type=script&lang=js"
export * from "./IssueReport.vue?vue&type=script&lang=js"
import style0 from "./IssueReport.vue?vue&type=style&index=0&id=3dd7d5f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7d5f1",
  null
  
)

export default component.exports